/**
 * Safe LocalStorage wrapper to prevent exceptions in restricted environments
 * (e.g. private browsing, third-party iframe blocks) or invalid JSON syntax errors
 * from crashing React initial state evaluation.
 */
export const safeLocalStorage = {
  getItem(key: string): string | null {
    try {
      if (typeof window === "undefined" || !window.localStorage) return null;
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  setItem(key: string, value: string): void {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem(key, value);
      }
    } catch {}
  },

  removeItem(key: string): void {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.removeItem(key);
      }
    } catch {}
  },

  clear(): void {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.clear();
      }
    } catch {}
  },

  getJson<T>(key: string, fallback: T): T {
    try {
      const val = this.getItem(key);
      if (!val) return fallback;
      return JSON.parse(val) as T;
    } catch {
      return fallback;
    }
  },

  setJson<T>(key: string, value: T): void {
    try {
      this.setItem(key, JSON.stringify(value));
    } catch {}
  }
};
